<ng-template #modal let-modal>
  <div class="modal-header">
    <h4>Assign assessment: {{ assessment.Title }}</h4>
  </div>

  <div class="d-flex col">
    <div style="width:100%">
      <div class="detail-name mb-2">Select Students:</div>
      <div ngbDropdown #studentsDropdown="ngbDropdown">

        <button type="button" class="btn btn-outline-secondary" id="dropdownForm1"
          style="color: black; font-weight: normal;" ngbDropdownToggle>
          {{ getSelectedStudentsText() }}
        </button>

        <div ngbDropdownMenu aria-labelledby="dropdownForm1">
          <!-- select student group -->
          <div *ngIf="!isWaiting" type="button" class="btn btn-primary btn-sm mx-2 mb-2"
            (click)="selectAllStudents()">Select All Students</div><br>
          <div *ngIf="!isWaiting" type="button" class="btn btn-primary btn-sm mx-2 mb-2"
            (click)="selectAttemptedStudents()">Select Attempted (did not pass)</div><br>
          <div *ngIf="!isWaiting" type="button" class="btn btn-deselect btn-sm mx-2"
            (click)="deselectAllStudents()">Deselect All Students</div><br>
          <hr class="my-2">

          <!-- select individual students -->
          <div class="scrollable">
            <div *ngFor="let selectedStudent of selectedStudents" class="d-flex hover mr-1"
              (click)="toggleStudent(selectedStudent)">
              <input class="my-1 mx-2" type="checkbox" [(ngModel)]="selectedStudent.include">
              <div class="my-1">{{ selectedStudent.student.Name }}</div>
            </div>
          </div>
          <hr class="my-2">

          <!-- footer -->
          <div class="d-flex justify-content-end">
            <div class="btn btn-primary mr-2" (click)="studentsDropdown.close();">OK</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer" style="border: none">
    <button *ngIf="!isWaiting" class="btn btn-secondary btn-lg" (click)="modal.dismiss('Cross click')">Cancel</button>
    <button *ngIf="!isWaiting" [disabled]="!isInputValid()" class="btn btn-primary btn-lg"
      (click)="requestAssessment()">Assign</button>
    <app-loading-spinner *ngIf="isWaiting" text="Requesting..."></app-loading-spinner>
  </div>

</ng-template>